import apis from ".";

export const getDiscountsList = async (sellerId, perPage, page, accessToken) => {
  try {
    const result = await apis.get(`/seller/get-discount-list?sellerId=${sellerId}&perPage=${perPage}&page=${page}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

  export const createDiscount = async (discountDto, accessToken) => {
    try {

      const result = await apis.post("/product/create-discount", discountDto, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  };


  export async function getDiscountList(data, token) {
    try {
      const result = await apis.get(
        `/seller/get-discount-list?sellerId=${
        data.sellerId
      }&perPage=5&page=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
}